import React from 'react';

const TeamCard = ({ name, designation, image, linkedinUrl }) => {
  return (
    <div className="group">
      <div className="relative overflow-hidden rounded-xl shadow-lg transition-transform duration-300 hover:scale-105">
        <img 
          src={image} 
          alt={name}
          className="w-full aspect-square object-cover"
        />
        {linkedinUrl && (
          <a 
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute bottom-4 right-4 bg-white/90 hover:bg-white rounded-full p-2 transition-all duration-300 hover:scale-110 shadow-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#0A66C2">
              <path d="M20.447 20.452H16.89v-5.569c0-1.328-.025-3.037-1.849-3.037-1.851 0-2.134 1.445-2.134 2.94v5.666H9.351V9h3.414v1.561h.048c.476-.9 1.637-1.849 3.369-1.849 3.601 0 4.267 2.37 4.267 5.455v6.285zM5.337 7.433c-1.099 0-1.99-.891-1.99-1.99s.891-1.99 1.99-1.99c1.098 0 1.989.891 1.989 1.99s-.891 1.99-1.989 1.99zM7.119 20.452H3.553V9h3.566v11.452z"/>
            </svg>
          </a>
        )}
      </div>
      <div className="mt-4 text-center">
        <h3 className="text-xl font-bold text-gray-900">{name}</h3>
        <p className="text-brand-blue mt-1">{designation}</p>
      </div>
    </div>
  );
};

export default TeamCard;
